import React, { useState } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Form, Input, Button, message, InputNumber } from 'antd'
import * as Constants from '../../../constants'
import { db } from '../../../config/Fire'

const FormNewProject = () => {
	const [isSaving, setIsSaving] = useState(false)
	const [form] = Form.useForm()

	const handleReset = () => {
		setIsSaving(false)
		form.resetFields()
		form.setFieldsValue({ travelHours: 0 })
	}

	const handleSubmit = values => {
		const date = new Date()
		const dateStr = `${date.getDate().toString().length === 1 ? '0' + date.getDate() : date.getDate()}/${(date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)}/${date.getFullYear()} ${date.getHours().toString().length === 1 ? '0' + date.getHours() : date.getHours()}:${date.getMinutes().toString().length === 1 ? '0' + date.getMinutes() : date.getMinutes()}`

		const newProjectKey = db.ref().child(Constants.MAIN_NODES.PROJECTS).push().key
		const projectData = {
			id: newProjectKey,
			name: values.name,
			latitude: values.latitude,
			longitude: values.longitude,
			travelHours: values.travelHours || 0,
			isActive: true,
			createDate: dateStr
		}

		submit(projectData, newProjectKey)
	}

	const submit = (projectData, projectKey) => {
		setIsSaving(true)
		db.ref(`${Constants.MAIN_NODES.PROJECTS}/${projectKey}`).set(projectData)
			.then(() => {
				setIsSaving(false)
				message.success('¡El proyecto se guardó exitósamente!')
				form.resetFields()
				form.setFieldsValue({ travelHours: 0 })
			})
			.catch((err) => {
				console.log('ERROR: ' + JSON.stringify(err))
				setIsSaving(false)
				message.error('Se produjo un error. Por favor, vuelva a intentarlo más tarde.')
			})
	}

	const initialValues = { travelHours: 0 }

	return (
		<Grid className="gridCont">
			<Form onFinish={handleSubmit} form={form} initialValues={initialValues}>
				<Row>
					<Col xs={12} sm={6} md={6}>
						<Form.Item name="name" rules={[{ required: true, message: 'Por favor, ingresa el nombre del proyecto' }]}>
							<Input placeholder="Nombre del proyecto"/>
						</Form.Item>
					</Col>
					<Col xs={12} sm={6} md={6}>
						<Form.Item name="latitude" rules={[{ required: true, message: 'Por favor, ingresa la latitud' }]}>
							<InputNumber 
								placeholder="Latitud" 
								style={{ width: '100%' }}
								step={0.000001}
								precision={6}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={6} md={6}>
						<Form.Item name="longitude" rules={[{ required: true, message: 'Por favor, ingresa la longitud' }]}>
							<InputNumber 
								placeholder="Longitud" 
								style={{ width: '100%' }}
								step={0.000001}
								precision={6}
							/>
						</Form.Item>
					</Col>
					<Col xs={12} sm={6} md={6}>
						<Form.Item name="travelHours" rules={[{ required: true, message: 'Por favor, ingresa las horas de traslado' }]}>
							<InputNumber 
								placeholder="Horas de traslado" 
								style={{ width: '100%' }}
								min={0}
								step={0.01}
								precision={2}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Form.Item>
					<Row center="xs">
						<Col xs={3} sm={3} md={3}></Col>
						<Col xs={3} sm={3} md={3}>
							{
								isSaving ?
									<Button type="primary" htmlType="submit" disabled={true} loading>
										Agregar proyecto
									</Button>
									:
									<Button type="primary" htmlType="submit" disabled={false}>
										Agregar proyecto
									</Button>
							}
						</Col>
						<Col xs={3} sm={3} md={3}>
							<Button onClick={handleReset}>
								Limpiar
							</Button>
						</Col>
						<Col xs={3} sm={3} md={3}></Col>
					</Row>
				</Form.Item>
			</Form>
		</Grid>
	)
}

FormNewProject.propTypes = {

}

export default FormNewProject

